<template>
    <v-tab-item :value="thisTab" class="fill-height">
        <v-layout column justify-center class="h-100">
            <div style="flex:1; overflow:hidden">
                <employment-doc-view
                    v-bind="{
                        value: fields,
                        pages,
                        mode: 'view',
                        hideZoom: true,
                    }"
                />
            </div>
            <v-divider />
            <div class="v-btn-group flex-wrap my-12">
                <v-btn
                    outlined
                    color="grey-d"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('exit')"
                >
                    <span class="grey-6--text">닫기</span>
                </v-btn>
                <v-btn
                    color="primary"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('next')"
                >
                    <span> 서명 시작 </span>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </v-layout>
    </v-tab-item>
</template>

<script>
import { initEmploymentContract } from "@/assets/variables";

import { TABS } from "../lib";

import EmploymentDocView from "@/components/dashboard/common/employment/doc/employment-doc-view.vue";

const thisTab = TABS.VIEW.value;

export default {
    components: {
        EmploymentDocView,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
        tab: { type: String, default: TABS.VIEW.value },
        shows: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        form: initEmploymentContract(),

        thisTab,
    }),
    computed: {
        isOn() {
            return this.shows && this.tab == thisTab;
        },
        pages() {
            return this.form?.form?.pages || [];
        },
        fields() {
            return this.form?.form?.fields || [];
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentContract(this.value);
        },

        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>
